import React, { Component } from "react";
import { Field } from "redux-form";
import { bindActionCreators } from "redux";
import _ from "lodash";
import {
	SelectField as RFSelectField,
	DatePicker
} from "redux-form-material-ui";
import Webcam from "react-webcam";
import { connect } from "react-redux";
import {
	MenuItem,
	RaisedButton,
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui";
import download from "downloadjs";
import Camera from "material-ui/svg-icons/image/camera-alt";
import {
	actionChangeAfiliadoProps,
	actionDownloadFile
} from "../../../actions/AfiliadoActions";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../../actions/ActionConstants";
import { AFILIADOS } from "../../../config/RoutesConstants";
import Util from "../../../common/Util";
import VerticalListFields from "../../../components/VerticalListFields/VerticalListFields";
import ImageSelector from "../../../components/ImageSelector/ImageSelector";
import {
	AFILIADO_ACTIVO,
	AFILIADO_INACTIVO,
	ROL_OPERADOR_RECAUDA,
	ROL_OPERADOR_AFFI
} from "../../../common/Constants";

class PersonalTab extends Component {
	constructor(props) {
		super(props);
		let state =
			this.props.modeCRU === MODE_CRU_CREATE
				? this.returnStateNewAfiliado()
				: this.props.modeCRU === MODE_CRU_UPDATE
					? this.returnStateEditAfiliado()
					: this.returnStateShowAfiliado();
		this.state = state;
	}

	componentWillMount() {
		if (!this.props.modeCRU) {
			this.props.history.push(AFILIADOS);
		}
	}

	returnStateShowAfiliado() {
		const state = {
			enableField: true,
			province: null,
			screenshot: null,
			disabledUploadPhoto: true,
			enableCamera: false
		};
		return state;
	}

	returnStateNewAfiliado() {
		return {
			disableCity: true,
			province: null,
			photo: false,
			screenshot: null,
			disabledUploadPhoto: false,
			enableCamera: false
		};
	}

	returnStateEditAfiliado() {
		return {
			disabledCity: false,
			province: null,
			photo: this.props.afiliado.person.photo ? true : false,
			disabledUploadPhoto: this.props.afiliado.person.photo ? true : false,
			screenshot: null,
			enableCamera: false
		};
	}
	handleChangeDeleteFlag() {
		this.setState({
			photo: false
		});
		this.props.actionChangeAfiliadoProps({
			photoChange: true,
			cameraPhoto: false
		});
	}
	generateAffiliateCard() {
		this.props.changeAfiliadoProps(true).then(() => {
			this.props.onSubmitGenerateCard();
		});
	}
	changeState(state) {
		this.setState(state);
	}
	onDownloadCredentialBack() {
		this.downloadFile("CredencialModelo.pdf");
	}

	downloadFile(fileName) {
		this.props.actionDownloadFile(fileName, this.returnDownload.bind(this));
	}

	returnDownload(blob) {
		download(blob, "Credencial Dorso");
	}
	capture = () => {
		const imageSrc = this.webcam.getScreenshot();
		//obtiene un encode64 que lo sube a firebase como data_url
		this.setState({
			screenshot: imageSrc,
			disabledUploadPhoto: true
		});
		this.props.actionChangeAfiliadoProps({
			photoChange: true,
			cameraPhoto: true
		});
		this.props.dispatchOnChange("person.photo", imageSrc);
	};
	renderBlank = () => {
		let mensaje = "No se generaron credenciales para este afiliado.";
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>{mensaje}</p>
				</TableRowColumn>
			</TableRow>
		);
	};
	renderBodyRows = listCards => {
		return _.map(listCards, (card, i) => {
			return (
				<TableRow key={i} style={{ height: "16px", fontSize: "13px" }}>
					<TableRowColumn style={{ width: "15%" }}>{i + 1}</TableRowColumn>
					<TableRowColumn>
						{Util.formatDateToShowNotHour(card.emission_date)}
					</TableRowColumn>
					<TableRowColumn>
						{Util.formatDateToShowNotHour(card.date_to)}
					</TableRowColumn>
				</TableRow>
			);
		});
	};
	render() {
		const videoConstraints = {
			width: 65,
			height: 65,
			facingMode: "user"
		};
		const disabled =
			this.props.rol === ROL_OPERADOR_RECAUDA ||
			this.props.modeCRU === MODE_CRU_SHOW;
		const disabledStatus = this.props.rol === ROL_OPERADOR_AFFI;
		return (
			<div className="center">
				<VerticalListFields
					titleText="Datos de Afiliación"
					titleClass="title-papercard-primary"
					paperClass="papercard top10 bottom20"
					contentClass="content-papercard-around"
				>
					<div className="columns-row-around bottom25">
						<Field
							name="registrationDate"
							component={DatePicker}
							floatingLabelText="Fecha de ingreso"
							format={Util.isoDateToJavascriptDate}
							DateTimeFormat={Intl.DateTimeFormat}
							locale="es-ES"
							maxDate={new Date()}
							parse={Util.formatDateToISODate}
							disabled={disabled}
						/>
						<Field
							name="status"
							component={RFSelectField}
							floatingLabelText="Estado"
							disabled={disabled || disabledStatus}
						>
							<MenuItem
								key={1}
								value={AFILIADO_ACTIVO}
								primaryText={AFILIADO_ACTIVO}
							/>
							<MenuItem
								key={2}
								value={AFILIADO_INACTIVO}
								primaryText={AFILIADO_INACTIVO}
							/>
						</Field>
					</div>
					<div className="columns-row-around bottom25 ">
						<div className="columns-column-between right20">
							<div className="columns-row-around">
								<div className="columns-column-between">
									<ImageSelector
										classNameIS={""}
										fieldName={"person.photo"}
										label={"Seleccionar foto"}
										labelInfo={
											"La imagen debe ser JPG, 65x65 y el peso menor a 300KB"
										}
										styleRenderPreviews={{ marginBottom: 45 }}
										styleButton={{ margin: 5, width: 300 }}
										imagePreviewUrl={
											this.state.screenshot
												? this.state.screenshot
												: this.props.modeCRU === MODE_CRU_UPDATE &&
												  this.props.afiliado.person.photo
													? this.props.afiliado.person.photo
													: ""
										}
										onChangeDeleteFlag={this.handleChangeDeleteFlag.bind(this)}
										onChangeState={() => this.changeState({ photo: true })}
										disabledUploadPhoto={
											(this.state.disabledUploadPhoto &&
												this.state.enableCamera) ||
											this.props.rol === ROL_OPERADOR_RECAUDA
										}
										fileSize={300000}
									/>
								</div>
								<div
									className="columns-column-between"
									style={!this.state.enableCamera ? { marginBottom: 40 } : null}
								>
									<RaisedButton
										label="Usar Cámara"
										labelPosition="before"
										icon={<Camera />}
										style={{ margin: 5, width: 300 }}
										disabled={
											this.props.rol === ROL_OPERADOR_RECAUDA ? true : false
										}
										onClick={() => {
											this.setState({ enableCamera: !this.state.enableCamera });
										}}
									/>
									{this.state.enableCamera ? (
										<div>
											<div className="" style={{ marginTop: 90 }}>
												<Webcam
													audio={false}
													height={180}
													ref={node => (this.webcam = node)}
													screenshotFormat="image/jpeg"
													width={300}
													videoConstraints={videoConstraints}
													screenshotQuality={1}
												/>
											</div>
											<RaisedButton
												label="Tomar Foto"
												primary
												style={{ margin: 5, width: 300 }}
												onClick={this.capture}
											/>
										</div>
									) : null}
								</div>
							</div>
							<div className="columns-column-between">
								<RaisedButton
									label="Imprimir Credencial"
									primary
									style={{ margin: 5 }}
									onClick={this.generateAffiliateCard.bind(this)}
									disabled={
										disabled
											? true
											: this.props.modeCRU === MODE_CRU_UPDATE &&
											  this.props.afiliado.status === AFILIADO_ACTIVO
												? false
												: true
									}
								/>
								<RaisedButton
									label="Imprimir Dorso"
									primary
									style={{ margin: 5 }}
									onClick={this.onDownloadCredentialBack.bind(this)}
									disabled={
										disabled
											? true
											: this.props.modeCRU === MODE_CRU_UPDATE &&
											  this.props.afiliado.status === AFILIADO_ACTIVO
												? false
												: true
									}
								/>
							</div>
						</div>
						<div className="columns-row-between bottom25">
							<Table selectable={false}>
								<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
									<TableRow>
										<TableHeaderColumn style={{ width: "15%" }}>
											Nro.
										</TableHeaderColumn>
										<TableHeaderColumn>Fecha de Emisión</TableHeaderColumn>
										<TableHeaderColumn>Fecha de Vencimiento</TableHeaderColumn>
									</TableRow>
								</TableHeader>
								<TableBody stripedRows displayRowCheckbox={false}>
									{!_.isEmpty(
										this.props.afiliado ? this.props.afiliado.listCards : null
									)
										? this.renderBodyRows(this.props.afiliado.listCards)
										: this.renderBlank()}
								</TableBody>
							</Table>
						</div>
					</div>
				</VerticalListFields>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		photoChange: store.afiliado.photoChange,
		afiliado: store.afiliado.afiliado,
		modeCRU: store.afiliado.modeCRU,
		rol: store.app.rol
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionChangeAfiliadoProps,
			actionDownloadFile
		},
		dispatch
	);
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PersonalTab);



// WEBPACK FOOTER //
// ./src/screens/Afiliado/Tabs/MembershipTab.js